import { createSelector } from '@reduxjs/toolkit';
import { RootState, StpCounterResponse } from '@va/aaas/shared/types';

export const selectStpRates = (state: RootState) => (state.get('app')?.stpRates ?? null) as StpCounterResponse;

export const selectStpLimit = createSelector(selectStpRates, (rates) =>
  rates?.pool ? rates.pool.limit : rates?.stpLimit,
);
export const selectStpConsumed = createSelector(selectStpRates, (rates) =>
  rates?.pool ? rates.pool.consumed : rates?.stpConsumed,
);
